import { Image } from "primereact/image";
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SuggestedUserItemComponent from "./SuggestedUserItemComponent";
import { Translate } from "react-auto-translate";

export const SuggestedUsers = ({ data = [], onProfileClick }) => {
  const navigate = useNavigate();
  const userState = useSelector((state) => state.user);

  return (
    <main className="m-3 px-1">
      <div className="text-xl text-color font-medium pt-1">
        <Translate>Suggested Users</Translate>
      </div>
      <div className="text-sm text-gray-500 py-3">
        <Translate>Here are some users you can interact with</Translate>
      </div>

      <div className="py-2 flex flex-column gap-3">
        {userState?.users?.map((user, index) => (
          <SuggestedUserItemComponent key={index.toString()} user={user} />
        ))}
      </div>
      <div style={{ height: "10vh" }} />
    </main>
  );
};
